import { render, staticRenderFns } from "./QuotationSettingsPage.vue?vue&type=template&id=6ef41d64"
import script from "./QuotationSettingsPage.vue?vue&type=script&lang=js"
export * from "./QuotationSettingsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports